"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientFileCategories_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var PatientFileCategories_Factory = /** @class */ (function () {
    function PatientFileCategories_Factory() {
    }
    PatientFileCategories_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CanInactivate: model.CanInactivate,
            IsEditable: model.IsEditable,
            IsSystemDefined: model.IsSystemDefined,
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SystemDefaultKey: model.SystemDefaultKey,
        };
        return result;
    };
    PatientFileCategories_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CanInactivate: model.CanInactivate,
            IsEditable: model.IsEditable,
            IsSystemDefined: model.IsSystemDefined,
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            SystemDefaultKey: model.SystemDefaultKey,
        };
        return result;
    };
    return PatientFileCategories_Factory;
}());
exports.PatientFileCategories_Factory = PatientFileCategories_Factory;
